module.exports = __webpack_public_path__ + "img/prio-blue-small.64b10776.png";